import { useNavigate, useParams } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import EditCategoryForm from "features/storages/categories/editCategoryForm"
import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import RightSidebarCategory from "components/sidebar/right/RightSidebarCategory"
import PageTitle from "features/navigation/pageTitle"
import useCategories from "hooks/useCategories"
import useStorages from "hooks/useStorages"
import { paramGuardStorage, paramGuardCategory } from "@/utils/paramGuard"
import { FormStatus } from "@/types"

const EditCategory = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const { targetStorageDocId: storageId } = useTargetStorage()
    const { categoryId } = useParams<{ categoryId: string }>()

    const { 
        category,
        categoryStatus 
    } = useCategories({ storageId, categoryId })
    const { 
        storage,
        storageStatus 
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (
        !paramGuardStorage({storageId, storage, storageStatus, navigate}) ||
        !paramGuardCategory({storageId, categoryId, category, categoryStatus, navigate})
    ) {
        return <></>
    }
    const safeStorageId = storageId!;
    const safeCategoryId = categoryId!;

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleEditCategory')} />
            <EditCategoryForm storageId={safeStorageId} categoryId={safeCategoryId} />
            <RightSidebarCategory categoryId={safeCategoryId} storageId={safeStorageId} />
        </>
    )
}

export default EditCategory